import { createSlice } from '@reduxjs/toolkit';
import { dispatch, RootState } from '../store';

export interface AppCurrency  {
  isLoading:boolean,
  currency:{
      code:string,
      symbol:string
  }
  err:any,
}

const initialState:AppCurrency = {
    
    isLoading:false,
    currency:{
        code:'USD',
        symbol:"$",
    },
    err: null
}

const slice = createSlice({
  name: 'app-currency',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.err = action.payload;
    },

    // GET APP Global Currency

    getCurrencySuccess(state,action){
      
      state.isLoading = false;
      state.currency = action.payload;
    }

  },
});

// Reducer
export default slice.reducer;

// Actions
export const {getCurrencySuccess} = slice.actions;


export function getGlobalCurrency(state:RootState){
  
  return async ()=>{
    
    dispatch(slice.actions.startLoading());

    dispatch(slice.actions.getCurrencySuccess(state.globalCurrency.currency)); 
  }
}
